'use client';

import { Button } from '@/components/ui/button';
import { ShoppingBag, Mail } from 'lucide-react';
import { isFoundingPartnerPhase } from '@/lib/feature-flags/launch-phase';

export function MobileStickyCta() {
  const founding = isFoundingPartnerPhase();

  const onClick = () => {
    if (founding) {
      window.location.assign('/contact?subject=early-access');
      return;
    }
    const checkoutUrl = process.env.NEXT_PUBLIC_STARTER_CHECKOUT_URL;
    if (checkoutUrl) {
      window.open(checkoutUrl, '_blank', 'noopener,noreferrer');
      return;
    }
    const pricing = document.getElementById('pricing');
    pricing?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="md:hidden fixed left-0 right-0 bottom-20 z-40 px-4">
      <div className="mx-auto max-w-md rounded-full border bg-background/95 shadow-lg">
        <Button onClick={onClick} className="w-full rounded-full py-5 text-base flex items-center justify-center gap-2">
          {founding ? (
            <>
              <Mail className="w-4 h-4" />
              Request Access
            </>
          ) : (
            <>
              <ShoppingBag className="w-4 h-4" />
              Buy Starter
            </>
          )}
        </Button>
      </div>
    </div>
  );
}
